<template>
  <v-container class="px-8">
    <v-slide-x-transition group hide-on-leave>
      <v-row
        v-for="(question, index) in questions"
        :key="'Transcript' + index"
        dense
        align="center"
        :class="!(index % 2) ? 'apply-back' : ''"
      >
        <v-col cols="12">
          <v-text-field
            prepend-icon="mdi-delete"
            @click:prepend="onDelete(index)"
            dense
            :rules="[rules.required]"
            v-model="question.content.word"
            label="Sentence"
          />
        </v-col>
        <v-col cols="12">
          <v-radio-group
            :column="false"
            v-model="question.good_answer"
            :rules="[rules.required]"
            class="mt-0"
            dense
          >
            <v-row justify="space-around">
              <v-radio value="A" color="#29284c">
                <template #label>
                  <v-text-field
                    @click.stop
                    dense
                    label="Option A"
                    v-model="question.content.A"
                    :rules="[rules.required]"
                  />
                </template>
              </v-radio>
              <v-radio value="B" color="#29284c">
                <template #label>
                  <v-text-field
                    @click.stop
                    dense
                    label="Option B"
                    v-model="question.content.B"
                    :rules="[rules.required]"
                  />
                </template>
              </v-radio>
            </v-row>
          </v-radio-group>
        </v-col>
      </v-row>
    </v-slide-x-transition>
    <v-btn color="#FF347C" class="white--text mx-auto d-flex mt-4" depressed @click="onNew">
      <v-icon left>mdi-plus</v-icon>Add New
    </v-btn>
  </v-container>
</template>
<script>
import rulesMixin from "@/mixins/rulesMixin";
import crudMixin from "@/mixins/crudMixin";
import { postQuestions } from "@/api/api";

export default {
  props: {
    question_group: {
      required: false,
      default: () => {},
      type: Object,
    },
  },
  mixins: [rulesMixin, crudMixin],
  data() {
    return {
      questions: [],
      defaultQuestion: () => ({
        title: "Transcript",
        content: {
          word: "",
          A: "",
          B: "",
        },
        good_answer: "",
      }),
    };
  },
  methods: {
    async save(uuid) {
      let questions = JSON.parse(JSON.stringify(this.questions));
      questions.forEach((element) => {
        element.content = JSON.stringify(element.content);
      });
      let question_group = {
        uuid,
        questions,
      };
      try {
        const response = await postQuestions(question_group);
        let questions = response.questions;
        questions.forEach((element) => {
          element.content = JSON.parse(element.content);
        });
        this.questions = questions;
        return response;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
  },
  created() {
    if (this.question_group.questions) {
      let questions = this.question_group.questions;
      this.questions = [...questions];
      this.questions.forEach((element) => {
        element.content = JSON.parse(element.content);
      });
    } else this.questions.push(this.defaultQuestion());
  },
};
</script>
<style scoped>
.apply-back {
  background: #e0f6ff !important;
}
</style>
